import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const paymentGatewayRBAC = {
  pageID: 'bcb52d107a1383e7fd094a39bc540ec9',
  elementID: {
    ButtonEdit: 'c834128bf888651429a257339d66784d',
    TableList: 'e9ed9b0add013eb01a5e2079ca1b26fb',
    ToggleState: 'ef43036bae8270eb8dd97660867d9c80',
  },
} as const

export const useRBACPaymentGatewayPage = createUseRBAC(paymentGatewayRBAC.elementID)

export type UseRBACPaymentGatewayPageType = ReturnType<typeof useRBACPaymentGatewayPage>
